import { useContext } from 'react';

import Context from '../../Context';

const ContainerComponent = ({ children }) => {
  const { isLoading, vat, classNames } = useContext(Context);

  return children({ vat: vat || '', isLoading, classNames });
};

ContainerComponent.displayName = 'LineItem-Vat-container';

export default ContainerComponent;
